// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file roamer/v1/roamer.proto (package roamer.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file roamer/v1/roamer.proto.
 */
export const file_roamer_v1_roamer: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Roamer is the wire shape of one live roaming NPC.
 *
 * It carries the archetype's presentation fields (key, name, prefab) rather
 * than only an archetype id, because an operator can add an archetype without a
 * client release: a client that had to resolve ids against a catalogue it
 * shipped with would render every new archetype as nothing at all.
 *
 * @generated from message roamer.v1.Roamer
 */
export type Roamer = Message<"roamer.v1.Roamer"> & {
  /**
   * npcs.id. This is also the combat target_id for TARGET_KIND_NPC.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * roamer_archetypes.key. The client resolves UI.Roamers/<key> for the
   * display name and falls back to display_name below when it does not know
   * the key — which is the normal case for an archetype authored after the
   * build shipped.
   *
   * @generated from field: string archetype_key = 2;
   */
  archetypeKey: string;

  /**
   * The operator's English label, carried as that fallback. NOT localized:
   * anything the client can localize, it already has.
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * Character model key, from internal/npc/vocabulary/prefabs.json. Empty means
   * "client picks its default".
   *
   * @generated from field: string prefab_key = 4;
   */
  prefabKey: string;

  /**
   * @generated from field: roamer.v1.Hostility hostility = 5;
   */
  hostility: Hostility;

  /**
   * npcs.state. 'idle' | 'alert' | 'pursuit' | 'engage' | 'lost' | 'return'.
   *
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * @generated from field: int32 health = 7;
   */
  health: number;

  /**
   * @generated from field: int32 max_health = 8;
   */
  maxHealth: number;

  /**
   * @generated from field: double lat = 9;
   */
  lat: number;

  /**
   * @generated from field: double lng = 10;
   */
  lng: number;

  /**
   * @generated from field: int32 attack_range_m = 11;
   */
  attackRangeM: number;

  /**
   * Who it is currently after, empty when nobody.
   *
   * @generated from field: string target_player_id = 12;
   */
  targetPlayerId: string;

  /**
   * Whether a mug may be attempted at all right now: mugging is enabled, the
   * archetype's attempt ceiling is not yet reached, and it is still alive.
   *
   * ADVISORY, NOT AUTHORITY. It exists so the client can grey a button instead
   * of offering an action that will be refused; Mug re-checks every one of
   * these server-side and this field is never what decides.
   *
   * @generated from field: bool muggable = 13;
   */
  muggable: boolean;

  /**
   * The building it spawned near, empty for none. Carried because "clear the
   * thugs off this corner" is a quest objective shape the kill event already
   * supports.
   *
   * @generated from field: string anchor_building_id = 14;
   */
  anchorBuildingId: string;
};

/**
 * Describes the message roamer.v1.Roamer.
 * Use `create(RoamerSchema)` to create a new message.
 */
export const RoamerSchema: GenMessage<Roamer> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 0);

/**
 * @generated from message roamer.v1.ListRoamersNearRequest
 */
export type ListRoamersNearRequest = Message<"roamer.v1.ListRoamersNearRequest"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: double radius_m = 3;
   */
  radiusM: number;

  /**
   * 0 = server default cap
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message roamer.v1.ListRoamersNearRequest.
 * Use `create(ListRoamersNearRequestSchema)` to create a new message.
 */
export const ListRoamersNearRequestSchema: GenMessage<ListRoamersNearRequest> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 1);

/**
 * @generated from message roamer.v1.ListRoamersNearResponse
 */
export type ListRoamersNearResponse = Message<"roamer.v1.ListRoamersNearResponse"> & {
  /**
   * @generated from field: repeated roamer.v1.Roamer roamers = 1;
   */
  roamers: Roamer[];

  /**
   * False when roamer_config.system_enabled is off. The list is then empty and
   * that is not an error — the client hides the whole feature rather than
   * showing an outage for something that is merely switched off.
   *
   * @generated from field: bool system_enabled = 2;
   */
  systemEnabled: boolean;
};

/**
 * Describes the message roamer.v1.ListRoamersNearResponse.
 * Use `create(ListRoamersNearResponseSchema)` to create a new message.
 */
export const ListRoamersNearResponseSchema: GenMessage<ListRoamersNearResponse> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 2);

/**
 * @generated from message roamer.v1.GetPublicConfigRequest
 */
export type GetPublicConfigRequest = Message<"roamer.v1.GetPublicConfigRequest"> & {
};

/**
 * Describes the message roamer.v1.GetPublicConfigRequest.
 * Use `create(GetPublicConfigRequestSchema)` to create a new message.
 */
export const GetPublicConfigRequestSchema: GenMessage<GetPublicConfigRequest> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 3);

/**
 * @generated from message roamer.v1.PublicConfig
 */
export type PublicConfig = Message<"roamer.v1.PublicConfig"> & {
  /**
   * @generated from field: bool system_enabled = 1;
   */
  systemEnabled: boolean;

  /**
   * @generated from field: bool mug_enabled = 2;
   */
  mugEnabled: boolean;

  /**
   * Metres. The client gates its own MUG button a few percent TIGHTER than
   * this, because the server's copy of the player's position is stale by the
   * time the RPC lands and a client gating at exactly the server bound offers
   * an action the server then refuses.
   *
   * @generated from field: int32 mug_range_m = 3;
   */
  mugRangeM: number;

  /**
   * Seconds between attempts against the same roamer by the same player.
   *
   * @generated from field: int32 mug_cooldown_seconds = 4;
   */
  mugCooldownSeconds: number;
};

/**
 * Describes the message roamer.v1.PublicConfig.
 * Use `create(PublicConfigSchema)` to create a new message.
 */
export const PublicConfigSchema: GenMessage<PublicConfig> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 4);

/**
 * @generated from message roamer.v1.MugRequest
 */
export type MugRequest = Message<"roamer.v1.MugRequest"> & {
  /**
   * npcs.id of the roamer.
   *
   * @generated from field: string npc_id = 1;
   */
  npcId: string;

  /**
   * Where the client thinks the player is. A HINT ONLY — the server uses the
   * canonical position from Redis (player:loc:{id}), exactly as ShotRequest
   * does, so a client cannot walk itself into range.
   *
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * Idempotency key. A replay within the dedup window returns the original
   * outcome rather than rolling again, so a retry on a flaky connection cannot
   * spend a second attempt against the ceiling.
   *
   * @generated from field: string client_mug_id = 4;
   */
  clientMugId: string;
};

/**
 * Describes the message roamer.v1.MugRequest.
 * Use `create(MugRequestSchema)` to create a new message.
 */
export const MugRequestSchema: GenMessage<MugRequest> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 5);

/**
 * @generated from message roamer.v1.MuggedItem
 */
export type MuggedItem = Message<"roamer.v1.MuggedItem"> & {
  /**
   * @generated from field: int32 item_catalog_id = 1;
   */
  itemCatalogId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 quantity = 3;
   */
  quantity: number;
};

/**
 * Describes the message roamer.v1.MuggedItem.
 * Use `create(MuggedItemSchema)` to create a new message.
 */
export const MuggedItemSchema: GenMessage<MuggedItem> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 6);

/**
 * @generated from message roamer.v1.MugOutcome
 */
export type MugOutcome = Message<"roamer.v1.MugOutcome"> & {
  /**
   * @generated from field: roamer.v1.MugResult result = 1;
   */
  result: MugResult;

  /**
   * What was taken. EMPTY IS A LEGITIMATE SUCCESS: the archetype's loot rows
   * are rolled independently and all of them can miss, which is "you got their
   * pockets and they were empty" — a different thing from being caught, and the
   * client says so.
   *
   * @generated from field: repeated roamer.v1.MuggedItem items = 2;
   */
  items: MuggedItem[];

  /**
   * @generated from field: int64 dirty_cash = 3;
   */
  dirtyCash: bigint;

  /**
   * Seconds left before this player may try this roamer again. Set on
   * MUG_RESULT_COOLDOWN, and also on a spent attempt so the client can start
   * its countdown without a second call.
   *
   * @generated from field: int32 cooldown_seconds = 4;
   */
  cooldownSeconds: number;

  /**
   * Whether the attempt made a defensive roamer hostile. The client uses this
   * to put the body straight into its combat pose rather than waiting for the
   * first npc_update to say so.
   *
   * @generated from field: bool npc_hostile_now = 5;
   */
  npcHostileNow: boolean;

  /**
   * The player's HP after the archetype's mug_fail_damage, when a failed
   * attempt cost them something. 0 when nothing was applied.
   *
   * @generated from field: int32 player_health_after = 6;
   */
  playerHealthAfter: number;

  /**
   * The player's heat after mug_heat_delta. 0 when nothing was applied.
   *
   * @generated from field: int32 heat_after = 7;
   */
  heatAfter: number;
};

/**
 * Describes the message roamer.v1.MugOutcome.
 * Use `create(MugOutcomeSchema)` to create a new message.
 */
export const MugOutcomeSchema: GenMessage<MugOutcome> = /*@__PURE__*/
  messageDesc(file_roamer_v1_roamer, 7);

/**
 * Hostility is what a roamer does about the player being there. It is on the
 * wire because the client has to decide whether to draw a threat ring and
 * whether to offer MUG before it has ever exchanged a packet about this
 * particular NPC.
 *
 * @generated from enum roamer.v1.Hostility
 */
export enum Hostility {
  /**
   * @generated from enum value: HOSTILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Never attacks, even when shot. A mark, not an enemy.
   *
   * @generated from enum value: HOSTILITY_PASSIVE = 1;
   */
  PASSIVE = 1,

  /**
   * Attacks only once the player attacks or mugs it.
   *
   * @generated from enum value: HOSTILITY_DEFENSIVE = 2;
   */
  DEFENSIVE = 2,

  /**
   * Attacks any player inside its aggro radius, unprovoked.
   *
   * @generated from enum value: HOSTILITY_AGGRESSIVE = 3;
   */
  AGGRESSIVE = 3,
}

/**
 * Describes the enum roamer.v1.Hostility.
 */
export const HostilitySchema: GenEnum<Hostility> = /*@__PURE__*/
  enumDesc(file_roamer_v1_roamer, 0);

/**
 * MugResult says what happened, in one value the client can switch on for copy.
 * The refusals are separate values rather than one error because they are all
 * ordinary outcomes with different things to tell the player: "get closer",
 * "wait", "there is nothing left to take".
 *
 * @generated from enum roamer.v1.MugResult
 */
export enum MugResult {
  /**
   * @generated from enum value: MUG_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Took something (or the pockets were empty — see the note on MugOutcome).
   *
   * @generated from enum value: MUG_RESULT_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * Rolled and lost. The attempt is spent.
   *
   * @generated from enum value: MUG_RESULT_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: MUG_RESULT_OUT_OF_RANGE = 3;
   */
  OUT_OF_RANGE = 3,

  /**
   * @generated from enum value: MUG_RESULT_COOLDOWN = 4;
   */
  COOLDOWN = 4,

  /**
   * roamer_config.mug_enabled is off, or the whole system is.
   *
   * @generated from enum value: MUG_RESULT_DISABLED = 5;
   */
  DISABLED = 5,

  /**
   * No such live roamer — despawned, killed, or never existed.
   *
   * @generated from enum value: MUG_RESULT_NOT_FOUND = 6;
   */
  NOT_FOUND = 6,

  /**
   * The archetype's mug_max_attempts ceiling is reached.
   *
   * @generated from enum value: MUG_RESULT_EXHAUSTED = 7;
   */
  EXHAUSTED = 7,

  /**
   * The player is downed and cannot act.
   *
   * @generated from enum value: MUG_RESULT_PLAYER_DOWNED = 8;
   */
  PLAYER_DOWNED = 8,

  /**
   * The player's street inventory could not hold what was taken.
   *
   * @generated from enum value: MUG_RESULT_NO_ROOM = 9;
   */
  NO_ROOM = 9,
}

/**
 * Describes the enum roamer.v1.MugResult.
 */
export const MugResultSchema: GenEnum<MugResult> = /*@__PURE__*/
  enumDesc(file_roamer_v1_roamer, 1);

/**
 * RoamerService is the player-facing surface of the roaming street-NPC system:
 * the people on the map who are neither quest givers nor police.
 *
 * WHY THIS IS A SERVICE AND NOT THREE MORE RPCs ON PoliceService. A live roamer
 * IS an `npcs` row, and it is attacked through the combat service exactly as a
 * police NPC is — TargetKind.NPC on ShotRequest, no new combat surface. So the
 * only things this service exists for are the two questions the existing wire
 * cannot answer: which roamers are near me and what do they look like, and the
 * one verb that is genuinely new — mugging. Bolting those onto PoliceService
 * would have made police.Npc carry archetype and hostility fields that mean
 * nothing for a guardian, and would have put a theft RPC behind a name that
 * says police.
 *
 * SERVED FROM THE npc BINARY alongside PoliceService, so it lands on the
 * existing npc host with no new ingress and nothing for the client to learn
 * beyond a service name.
 *
 * ATTACKING A ROAMER IS NOT HERE, deliberately. It is combat.v1.CombatService's
 * Shoot with target_kind = TARGET_KIND_NPC and target_id = the roamer's npcs.id.
 * The damage is applied by the npc_tick worker, which is the only writer of
 * npcs.health, and the authoritative result reaches every client through the
 * npc_update realtime frame — the same path a shot at a guardian already takes.
 *
 * @generated from service roamer.v1.RoamerService
 */
export const RoamerService: GenService<{
  /**
   * Which roamers are near the player, for the client's hydrate loop. Mirrors
   * PoliceService.ListNpcsNear: the realtime npc_spawned frame is only seen by
   * clients already in the cell room at publish time, so a player who walks in,
   * reconnects, or cold-starts needs a snapshot to catch up.
   *
   * @generated from rpc roamer.v1.RoamerService.ListRoamersNear
   */
  listRoamersNear: {
    methodKind: "unary";
    input: typeof ListRoamersNearRequestSchema;
    output: typeof ListRoamersNearResponseSchema;
  },
  /**
   * Attempt to steal from a roamer without killing it.
   *
   * SERVER-AUTHORITATIVE END TO END. The client sends nothing but which roamer
   * and where it thinks it is standing; the server resolves the player's
   * canonical position from Redis, checks range and cooldown and the archetype's
   * attempt ceiling, rolls the outcome, and grants whatever was taken inside one
   * transaction. There is no client-supplied roll and no client-side grant — the
   * rule the rewarded-ads integration states applies here for the same reason.
   *
   * @generated from rpc roamer.v1.RoamerService.Mug
   */
  mug: {
    methodKind: "unary";
    input: typeof MugRequestSchema;
    output: typeof MugOutcomeSchema;
  },
  /**
   * The player-readable slice of roamer_config: whether the system is on at
   * all, whether mugging is offered, and the two numbers the CLIENT has to act
   * on rather than merely obey (the mug range it gates its own button on, and
   * the cooldown it counts down). Every other dial in that row is the spawn
   * simulation, which the client neither runs nor needs to see.
   *
   * Cheap by construction — it reads the already-cached config pointer, no
   * player state and no database round trip — which is what makes it safe to
   * call on every login and reconnect, the same as its police/building twins.
   *
   * @generated from rpc roamer.v1.RoamerService.GetPublicConfig
   */
  getPublicConfig: {
    methodKind: "unary";
    input: typeof GetPublicConfigRequestSchema;
    output: typeof PublicConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_roamer_v1_roamer, 0);

